<template>
    <section class="content__wrapper__container">
        <div class="content">
            <div class="left">
                <slot name="category"></slot>
            </div>
            <div class="right">
                <slot name="product"></slot>
                <slot name="list-flip"></slot>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>
.content{
    display: flex;
    gap: 27px;
    padding-top: 24px;
    padding-bottom: 24px;
}
.left{
    width: calc(25% - 13.5px);
    max-width: 303px;
}
.right{
    width: calc(77% - 13.5px);
}
@media (max-width: 1024px) {
    .left{
        width: 0px;
    }
    .content{
        gap: unset;
    }
    .right{
        width: 100%;
    }
}
</style>